<template>
  <div class="card-pos" v-show="isLoad">
    <div class="card" @click="$emit('returnEmit',dataEmitClick(false))">
      <div>
        <span class="badge badge-info px-2 text-black custom-line" :class="starShow ? 'left' : 'right' ">{{courier.name}}</span>
        <span v-if="starShow && courier.favorites_at && roleCheck.isAdmin" id="star" class="star bi bi-star-fill yellow-color cursor-pointer" @click="$emit('returnEmit',dataEmitClick(true,'delete',$event))"></span>
        <span v-else-if="starShow && roleCheck.isAdmin" id="star" class="star bi bi-star yellow-color cursor-pointer" @click="$emit('returnEmit',dataEmitClick(true,'',$event))"></span>
      </div>
      <div class="card-body">
        <img class="card-img-top mt-3" :src="url" img-alt="Image"/>
      </div>
      <div class="card-footer text-center">
        <div class="card-text text-truncate-pos" v-b-tooltip :title="courier.title">{{courier.title}}</div>
        <div v-if="courier.cutoff_times && courier.cutoff_times.length > 0">
            <div class="card-text cut-off-text" v-if="cutOffRefer">
                <Icon icon="akar-icons:clock" class="c-icon" /> ตัดรอบ {{courier.cutoff_times[0].label}}
            </div>
            <div class="card-text cut-off-text" v-else-if="cutOffIntime">
                <span class="pr-1"><Icon icon="akar-icons:clock" class="c-icon" /></span>ตัดรอบ{{courier.cutoff_times[0].label}}
            </div>
            <div class="card-text cut-off-b text-center" v-else-if="cutOff" v-b-tooltip.hover.bottom.html="cutoffTip">
                <Icon icon="charm:info" class="c-icon" /> ตัดรอบแล้ว
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "cardpos",
  props: ["courier", "disabled" ,"lockcourier","starShow","prebarcode"],
  data() {
    return {
      url: "/img/brand/load-error.svg" ,
      isLoad: false,
      cutoffTip : "หากสร้างรายการหลังจากตัดรอบแล้วพัสดุจะถูกเข้ารับในวันถัดไป",
      time : new Date().getHours(),
      roleCheck : this.$USER_LOGIN.get()
    };
  },
  methods: {
    cutOff() {
      return this.courier.cutoff_times[0].hasOwnProperty('time') && parseInt(this.courier.cutoff_times[0].time.split(':')[0]) <= this.time
    },
    cutOffIntime() {
      return this.courier.cutoff_times[0].hasOwnProperty('label') && this.courier.cutoff_times[0].label === 'ตามเวลาสาขา'
    },
    cutOffRefer() {
      return this.courier.cutoff_times[0].hasOwnProperty('time') && this.courier.cutoff_times[0].time != '' && parseInt(this.courier.cutoff_times[0].time.split(':')[0]) > this.time
    },
    dataEmitClick(checkout, actions, event) {
      return {event: event, courier: this.courier,prebarcode: this.prebarcode,clickON: checkout ? true : false ,deleteON: actions === 'delete' ? true : false}
    },
    async getIcon() {
      this.isLoad = false
      let icon = this.courier.icon ? this.courier.icon : (this.$THEME.name == 'shippop') ? "default_courier_shippop.svg" :"default_courier.svg";

        if( this.$THEME.name == 'poststation' ){
            if( icon == 'EMSXP.png' ){
                icon = 'THP.png'
            }else if( icon == 'PRE_EMSXP.png' ){
                icon = 'PRE_THP.png'
            }
        }

      const path = this.courier.type && this.courier.type === 'service' ? 
      `/icon/additional_service/${icon}` : `/icon/${icon}`

      if( icon == 'shippop-logo' ){

        this.url = 'img/brand/logo-shippop.png'

      }else{
        const storageRef = this.$firebase.storage().ref( path ).getDownloadURL()
        storageRef.then( res => {
          this.url = res
          // eslint-disable-next-line
        }).catch( err => { 
          if ('icon-inter-parcel.png' == icon) {
            this.url = "/img/brand/load-error.svg"
          } else if (['scg-cool.png'].includes(icon)) {
            this.url = "/img/courier_icons/SCGC.png"
          } else if (['scg-frozen.png'].includes(icon)) {
            this.url = "/img/courier_icons/SCGF.png"
          } else if (['scg-express-yamato.png'].includes(icon)) {
            this.url = "/img/courier_icons/SCG.png"
          } else if (['fle_nodimension.jpg'].includes(icon)) {
            this.url = "/img/courier_icons/FLE.png"
          } else {
            this.url = "/img/courier_icons/" + icon
          }
        })

      }
      this.isLoad = true
    },
    checkTheme(){
        return ['shipsbuy'].includes(this.$THEME.name)
    }
  },
  beforeMount(){
    this.getIcon()
  }
};
</script>
<style>
</style>
